import { gql } from "@apollo/client";

const ACCOUNT_QUERY = {
	GET_MY_ACCOUNT: gql`
		{
			getAdminProfile {
				uid
				email
				userProfile {
					firstName
					lastName
				}
			}
		}
	`,
	EDIT_MY_ACCOUNT: gql`
		mutation ($email: String, $firstName: String, $lastName: String) {
			updateAdminProfile(
				data: { email: $email, firstName: $firstName, lastName: $lastName }
			)
		}
	`,
	CREATE_ADMIN: gql`
		mutation (
			$email: String
			$firstName: String
			$lastName: String
			$password: String
		) {
			createAdmin(
				data: {
					email: $email
					firstName: $firstName
					lastName: $lastName
					password: $password
				}
			)
		}
	`,
	UPDATE_ADMIN_LAST_LOGIN_AT: gql`
		mutation {
			updateAdminLastLoginAt
		}
	`,
};
export default ACCOUNT_QUERY;
